import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Statistic, List, Avatar, Tag, Typography, message, Grid } from 'antd';
import { UserOutlined, CheckCircleOutlined, RocketOutlined } from '@ant-design/icons';
import api from '../../api/axios';

const { Title, Text } = Typography;
const { useBreakpoint } = Grid; // RESPONSIVE CHANGE

const MentorDashboard = () => {
    const [data, setData] = useState({ stats: {}, recent_activity: [] });
    const [loading, setLoading] = useState(true);
    const screens = useBreakpoint(); // RESPONSIVE CHANGE

    useEffect(() => {
        const fetchDashboard = async () => {
            try {
                const res = await api.get('/mentor/dashboard');
                setData(res.data);
            } catch (e) {
                message.error("Failed to load dashboard stats");
            } finally {
                setLoading(false);
            }
        };
        fetchDashboard();
    }, []);

    return (
        // RESPONSIVE CHANGE: Reduce padding on mobile
        <div style={{ padding: screens.xs ? '12px' : '24px' }}>
            <Title level={screens.xs ? 4 : 2}>Mentor Dashboard</Title>
            <Text type="secondary">Welcome back! Here is an overview of your mentorship activities.</Text>

            <Row gutter={[16, 16]} style={{ marginTop: screens.xs ? 16 : 24 }}>
                <Col xs={24} sm={12} lg={8}>
                    <Card bordered={false} style={{ borderLeft: '4px solid #FE1F08' }}>
                        <Statistic 
                            title="Active Mentees" 
                            value={data.stats.total_mentees} 
                            prefix={<UserOutlined />} 
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} lg={8}>
                    <Card bordered={false} style={{ borderLeft: '4px solid #FE1F08' }}>
                        <Statistic 
                            title="Pending Milestones" 
                            value={data.stats.pending_confirmations} 
                            valueStyle={{ color: '#FE1F08' }}
                            prefix={<CheckCircleOutlined />} 
                        />
                    </Card>
                </Col>
            </Row>

            <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                <Col span={24}>
                    <Card 
                        title={<span><RocketOutlined /> Recent Activity</span>}
                        // RESPONSIVE CHANGE: Tighten card padding on mobile
                        bodyStyle={{ padding: screens.xs ? '8px' : '24px' }}
                    >
                        <List
                            // RESPONSIVE CHANGE: Vertical layout on mobile prevents squashing
                            itemLayout={screens.xs ? "vertical" : "horizontal"}
                            dataSource={data.recent_activity}
                            loading={loading}
                            renderItem={item => (
                                <List.Item
                                    // RESPONSIVE CHANGE: Move the Tag below the text on mobile for better flow
                                    extra={!screens.xs && (
                                        <Tag color={item.status === 'confirmed_by_mentor' ? 'green' : 'blue'}>
                                            {item.status.replace(/_/g, ' ').toUpperCase()}
                                        </Tag>
                                    )}
                                >
                                    <List.Item.Meta
                                        avatar={<Avatar style={{ backgroundColor: '#FE1F08' }} icon={<UserOutlined />} />}
                                        title={<Text strong>{item.commitment?.people_match?.mentee?.name}</Text>}
                                        description={
                                            <div>
                                                <Text type="secondary">Updated milestone: "{item.title}"</Text>
                                                {/* RESPONSIVE CHANGE: Show Tag here instead of "extra" for mobile */}
                                                {screens.xs && (
                                                    <div style={{ marginTop: 8 }}>
                                                        <Tag color={item.status === 'confirmed_by_mentor' ? 'green' : 'blue'}>
                                                            {item.status.replace(/_/g, ' ').toUpperCase()}
                                                        </Tag>
                                                    </div>
                                                )}
                                            </div>
                                        }
                                    />
                                </List.Item>
                            )}
                        />
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default MentorDashboard;